import type { TranslationMessages } from '../../types';

export const timesheet: TranslationMessages = {
  title: 'Attendance Records',
  subtitle: 'View and manage your attendance records and timesheet',
  calendar_view: 'Calendar View',
  list_view: 'List View',
  total_hours: 'Total Hours',
  overtime_hours: 'Overtime Hours',
  regular_hours: 'Regular Hours',
  export_pdf: 'Export PDF',
  export_excel: 'Export Excel',
  export_csv: 'Export CSV',
  date_range: 'Date Range',
  start_date: 'Start Date',
  end_date: 'End Date',
  apply_filter: 'Apply Filter',
  clear_filter: 'Clear Filter',
  no_records: 'No attendance records found',
  no_records_title: 'No Attendance Records',
  no_records_description:
    'No attendance records available. Use the Check-in/Check-out tab to create your first attendance record.',
  no_filtered_records_description: 'No records match your current filters.',
  go_to_checkin: 'Go to Check-in/Check-out',
  filters_title: 'Filters',
  search_label: 'Search',
  search_placeholder: 'Search records...',
  date_label: 'Date',
  status_label: 'Status',
  status_all: 'All',
  status_present: 'Present',
  status_absent: 'Absent',
  stats_total_days: 'Total Days',
  stats_total_days_hint: 'Last 30 days',
  stats_present_days: 'Present Days',
  stats_present_days_hint: 'Days attended',
  stats_absent_days: 'Absent Days',
  stats_absent_days_hint: 'Days missed',
  stats_total_hours: 'Total Hours',
  stats_total_hours_hint: 'Hours worked',
  calendar_tab_label: 'Calendar',
  list_tab_label: 'List',
  view_day: 'Day',
  view_week: 'Week',
  view_month: 'Month',
  view_year: 'Year',
  today_label: 'Today',
  this_week_label: 'This Week',
  this_month_label: 'This Month',
  this_year_label: 'This Year',
  legend_complete: 'Complete',
  legend_partial: 'Partial',
  legend_absent: 'Absent',
  list_user_label: 'User',
};
